(() => {
  const root = document.querySelector('[data-perfume-filters]');
  if (!root || root.dataset.bound) return;
  root.dataset.bound = 'true';
  const catalog = root.closest('[data-bba-catalog]');
  const container = catalog.querySelector('#ProductGridContainer');
  const sectionId = container.querySelector('#product-grid').dataset.id;
  const strings = JSON.parse(root.querySelector('[data-perfume-strings]').textContent);
  const status = root.querySelector('[role=status]');
  const retry = root.querySelector('[data-perfume-retry]');
  const key = 'bba_perfume';
  const memberships = { men: 'men-perfumes', women: 'women-perfumes' };
  const cache = new Map();
  let desired = new URLSearchParams(location.search), state = new URLSearchParams(desired);
  let records = [], matches = [], shown = 12, revision = 0, timer, observer;
  const create = (tag, cls, text) => {
    const el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text !== undefined) el.textContent = text;
    return el;
  };
  const eligible = (items, params) => memberships[params.get(key)] ? items.filter(item => item.collections.includes(memberships[params.get(key)])) : items;
  const countText = count => strings.products.replace('__COUNT__', count);
  const values = (params, name) => params.getAll(name).flatMap(value => value.split(','));
  async function loadAll(params) {
    const url = new URL(root.dataset.url, location.origin);
    for (const [name, value] of params) if (name !== key && name !== 'page' && name !== 'section_id') url.searchParams.append(name, value);
    url.searchParams.set('sort_by', params.get('sort_by') || root.dataset.defaultSort);
    url.searchParams.set('section_id', 'bba-perfume-source');
    url.searchParams.sort();
    if (!cache.has(url.href)) cache.set(url.href, (async () => {
      let next = url, total;
      const all = [], ids = new Set(), pages = new Set();
      while (next) {
        if (pages.has(next.href) || next.origin !== location.origin) throw Error('Invalid pagination');
        pages.add(next.href);
        const response = await fetch(next, { credentials: 'same-origin', signal: AbortSignal.timeout(30000) });
        if (!response.ok) throw Error('Could not load collection');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const page = JSON.parse(doc.querySelector('[data-perfume-page]').textContent);
        total = page.total;
        for (const template of doc.querySelectorAll('[data-perfume-record]')) {
          const item = JSON.parse(template.content.querySelector('[data-perfume-meta]').textContent);
          const card = template.content.querySelector('li.grid__item');
          if (!card || ids.has(item.id)) throw Error('Invalid collection record');
          ids.add(item.id); all.push({ ...item, card });
        }
        next = page.next ? new URL(page.next, location.origin) : null;
        if (next) for (const [name, value] of url.searchParams) if (name !== 'page' && !next.searchParams.has(name)) next.searchParams.append(name, value);
      }
      if (all.length !== total) throw Error('Incomplete collection');
      return all.filter(item => item.available).concat(all.filter(item => !item.available));
    })().catch(error => { cache.delete(url.href); throw error; }));
    return cache.get(url.href);
  }
  async function facetCounts(params) {
    const options = new Map();
    for (const input of catalog.querySelectorAll('facet-filters-form input[type=checkbox]')) options.set(`${input.name}\n${input.value}`, input);
    return new Map(await Promise.all([...options].map(async ([id, input]) => {
      const query = new URLSearchParams(params);
      query.delete(input.name); query.append(input.name, input.value);
      return [id, eligible(await loadAll(query), params).length];
    })));
  }
  function writeHistory(mode) {
    const url = new URL(location.href); url.search = state.toString();
    history[mode === 'replace' ? 'replaceState' : 'pushState']({ searchParams: state.toString() }, '', url);
  }
  function renderGrid(append = false, focus = false) {
    observer?.disconnect();
    const collection = append ? container.querySelector('.collection') : create('div', 'collection');
    if (matches.length) {
      const grid = append ? collection.querySelector('#product-grid') : create('ul', 'grid product-grid grid--2-col-tablet-down grid--3-col-desktop bba-catalog__products');
      grid.id = 'product-grid'; grid.dataset.id = sectionId; grid.setAttribute('role', 'list');
      for (const record of matches.slice(append ? grid.children.length : 0, shown)) grid.append(document.importNode(record.card, true));
      if (!append) collection.append(grid);
      collection.querySelector('.bba-catalog__more')?.remove();
      const more = create('div', 'bba-catalog__more');
      if (shown < matches.length) {
        const button = create('button', 'bba-catalog__button', strings.more); button.type = 'button'; button.dataset.perfumeMore = ''; more.append(button);
      }
      const progress = create('p', '', strings.progress.replace('__SHOWN__', Math.min(shown, matches.length)).replace('__TOTAL__', matches.length));
      progress.setAttribute('role', 'status'); progress.setAttribute('aria-live', 'polite'); progress.tabIndex = -1;
      more.append(progress); collection.append(more);
    } else {
      const empty = create('div', 'bba-catalog__empty'); empty.id = 'product-grid'; empty.dataset.id = sectionId;
      empty.append(create('h2', '', strings.empty), create('p', '', strings.fewer));
      const clear = create('button', 'bba-catalog__button', strings.clear); clear.type = 'button'; clear.dataset.perfumeClear = ''; empty.append(clear); collection.append(empty);
    }
    if (!append) container.replaceChildren(collection);
    if (focus) collection.querySelector('[role=status]')?.focus({ preventScroll: true });
    const more = collection.querySelector('[data-perfume-more]');
    if (more && window.IntersectionObserver) {
      const generation = revision;
      observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting) && generation === revision && more.isConnected && root.getAttribute('aria-busy') !== 'true') appendNext();
      }, { rootMargin: '0px 0px 400px 0px' });
      observer.observe(more);
    }
  }
  function appendNext(focus = false) {
    if (root.getAttribute('aria-busy') === 'true' || shown >= matches.length) return;
    shown = Math.min(shown + 12, matches.length);
    state.set('page', Math.ceil(shown / 12)); desired = new URLSearchParams(state);
    writeHistory('replace'); renderGrid(true, focus);
  }
  function updateControls(counts) {
    for (const button of root.querySelectorAll('[data-perfume]')) {
      const selected = state.get(key) === button.dataset.perfume;
      const count = records.filter(record => record.collections.includes(memberships[button.dataset.perfume])).length;
      button.setAttribute('aria-pressed', String(selected)); button.querySelector('[data-perfume-count]').textContent = count;
    }
    for (const input of catalog.querySelectorAll('facet-filters-form input[type=checkbox]')) {
      input.checked = values(state, input.name).includes(input.value);
      const count = counts.get(`${input.name}\n${input.value}`);
      input.disabled = !count && !input.checked;
      const label = input.closest('label'); label?.classList.toggle('disabled', input.disabled);
      const text = label?.querySelector('.facet-checkbox__text');
      if (text) { for (const child of [...text.childNodes]) if (child.nodeType === Node.TEXT_NODE) child.remove(); text.append(document.createTextNode(` (${count})`)); }
      const hidden = label?.querySelector('.visually-hidden');
      if (hidden) hidden.textContent = `${label.querySelector('.facet-checkbox__text-label').textContent} (${countText(count)})`;
    }
    for (const detail of catalog.querySelectorAll('details.js-filter')) {
      const count = detail.querySelectorAll('input[type=checkbox]:checked').length;
      const badge = detail.querySelector('.facets__selected');
      if (badge) { badge.textContent = ` (${count})`; badge.classList.toggle('hidden', !count); }
      const label = detail.querySelector('.facets__summary-label');
      if (label) detail.querySelector('summary').setAttribute('aria-label', `${label.firstChild.textContent.trim()} (${strings.selected.replace('__COUNT__', count)})`);
    }
    for (const input of catalog.querySelectorAll('price-range input')) if (document.activeElement !== input) input.value = state.get(input.name) || '';
    for (const select of catalog.querySelectorAll('select[name=sort_by]')) select.value = state.get('sort_by') || root.dataset.defaultSort;
    for (const el of catalog.querySelectorAll('#ProductCount, #ProductCountDesktop, .mobile-facets__count')) { el.textContent = countText(matches.length); el.dataset.productCount = matches.length; el.classList.remove('loading'); }
    for (const holder of catalog.querySelectorAll('.active-facets-desktop, .active-facets-mobile')) {
      holder.replaceChildren();
      for (const name of new Set(state.keys())) {
        if (!name.startsWith('filter.') && name !== key) continue;
        for (const value of values(state, name)) {
          const input = [...catalog.querySelectorAll('facet-filters-form input')].find(el => el.name === name && el.value === value);
          const text = name === key ? root.querySelector(`[data-perfume="${value}"] > span`)?.textContent : input?.closest('label')?.querySelector('.facet-checkbox__text-label')?.textContent;
          const label = text || `${name.endsWith('.gte') ? '≥ ' : name.endsWith('.lte') ? '≤ ' : ''}${value}`;
          const button = create('button', 'active-facets__button bba-perfume-active'); button.type = 'button'; button.dataset.perfumeRemove = name; button.dataset.value = value;
          button.setAttribute('aria-label', strings.remove.replace('__LABEL__', label)); button.append(create('span', 'active-facets__button-inner', `${label} ×`)); holder.append(button);
        }
      }
      if (holder.children.length) { const clear = create('button', 'active-facets__button bba-perfume-active', strings.clear); clear.type = 'button'; clear.dataset.perfumeClear = ''; holder.append(clear); }
    }
  }
  async function apply(params, mode = 'push') {
    const generation = ++revision; observer?.disconnect(); desired = new URLSearchParams(params);
    if (!memberships[params.get(key)]) params.delete(key);
    root.setAttribute('aria-busy', 'true'); container.setAttribute('aria-busy', 'true'); status.textContent = strings.loading; retry.hidden = true;
    try {
      const [all, counts] = await Promise.all([loadAll(params), facetCounts(params)]);
      if (generation !== revision) return;
      records = all; state = new URLSearchParams(params); desired = new URLSearchParams(state); matches = eligible(records, state);
      shown = Math.min(matches.length, Math.max(12, (Number(state.get('page')) || 1) * 12));
      if (mode !== 'none') writeHistory(mode);
      root.setAttribute('aria-busy', 'false'); container.setAttribute('aria-busy', 'false');
      renderGrid(); updateControls(counts); status.textContent = ''; catalog.dataset.perfumeReady = 'true';
    } catch (error) {
      if (generation !== revision) return;
      status.textContent = strings.error; retry.hidden = false; root.setAttribute('aria-busy', 'false'); container.setAttribute('aria-busy', 'false');
    }
  }
  const clearAll = params => { for (const name of [...params.keys()]) if (name.startsWith('filter.') || name === key || name === 'page') params.delete(name); };
  catalog.addEventListener('input', event => {
    const input = event.target;
    if (!input.closest('facet-filters-form') || !input.name) return;
    event.stopImmediatePropagation(); clearTimeout(timer); ++revision; observer?.disconnect();
    const next = new URLSearchParams(desired); next.delete('page'); next.delete(input.name);
    if (input.type === 'checkbox') {
      for (const checked of input.closest('form').querySelectorAll('input[type=checkbox]:checked')) if (checked.name === input.name) next.append(input.name, checked.value);
    } else if (input.value) next.set(input.name, input.value);
    desired = next; timer = setTimeout(() => apply(next), 180);
  }, true);
  catalog.addEventListener('click', event => {
    const pill = event.target.closest('[data-perfume]'), remove = event.target.closest('[data-perfume-remove]');
    const clear = event.target.closest('[data-perfume-clear]'), native = event.target.closest('facet-remove a');
    const more = event.target.closest('[data-perfume-more], [data-bba-load-more]');
    if (!pill && !remove && !clear && !native && !more && !event.target.closest('[data-perfume-retry]')) return;
    event.preventDefault(); event.stopImmediatePropagation(); clearTimeout(timer);
    if (more) { if (catalog.dataset.perfumeReady) appendNext(true); else apply(desired); return; }
    const next = new URLSearchParams(desired); next.delete('page');
    if (pill) { if (next.get(key) === pill.dataset.perfume) next.delete(key); else next.set(key, pill.dataset.perfume); }
    else if (remove) { const remaining = values(next, remove.dataset.perfumeRemove).filter(value => value !== remove.dataset.value); next.delete(remove.dataset.perfumeRemove); for (const value of remaining) next.append(remove.dataset.perfumeRemove, value); }
    else if (clear || native) {
      const group = native?.closest('details')?.querySelector('input[name]')?.name;
      if (group) { next.delete(group); if (group.startsWith('filter.v.price')) { next.delete('filter.v.price.gte'); next.delete('filter.v.price.lte'); } }
      else clearAll(next);
    }
    apply(next);
  }, true);
  window.addEventListener('popstate', event => { event.stopImmediatePropagation(); clearTimeout(timer); apply(new URLSearchParams(location.search), 'none'); }, true);
  apply(state, 'none');
})();
